export const getMs = (seconds) => seconds * 1000;

export const wait = (seconds) =>
    new Promise((resolve) => setTimeout(() => resolve(), getMs(seconds)));
